package fr.arcplex.sooner

import androidx.compose.ui.ExperimentalComposeUiApi
import androidx.compose.ui.window.ComposeViewport
import fr.arcplex.sooner.infrastructure.PageManager

@OptIn(ExperimentalComposeUiApi::class)
fun main() {
    // initCoil()
    val identity = getWebIdentity()
    val pageManager = PageManager(identity)
    pageManager.onFilmSelectedListener = { id ->
        if (id != null) {
            pageManager.fetchFilm(id)
        }
    }
    pageManager.onVideoSelectedListener = { item ->
        pageManager.playVideo(item)
    }
    pageManager.start()

    ComposeViewport {
        App(pageManager)
    }
}
